export const INITIAL_STATE = {
    discussions: {},
    activeDiscussion: {},
};
